<template>
  <div
    depressed
    style="border-radius: 0; width: 100%; cursor: pointer; height: 100%; border-right: 1px solid white !important"
    class="ma-0 py-2 white--text"
    :class="{ primary: value == app, grey: value != app }"
    :color="value == app ? 'primary' : 'grey'"
    @click="$emit('changeApp', app)"
    dark
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['value', 'app']
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatTabItem.vue